export default "__VITE_ASSET__7a70fa76__"